import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { useMaterialUIController, addAlert } from "context";
import React, { useState, useEffect } from "react";
import { postRoleDO, updateRoleDo } from "utils/rolesUtils";
import { Autocomplete } from "@mui/material";
import { getGeneralCodes } from "utils/generalCodesUtils";
import { GeneralCode, GeneralCodeType } from "models/content/GeneralCode";
const MDInput = require("components/MDInput").default;

export const RoleDialog = ({ role, onSubmit }) => {
  const [controller, dispatch] = useMaterialUIController();
  const [roleName, setRoleName] = useState("");
  const [description, setDescription] = useState("");
  const [type, setType] = useState<GeneralCode | null>(null);
  const [roleTypes, setRoleTypes] = useState<GeneralCode[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getGeneralCodes(GeneralCodeType.RoleType).then((types) => {
      // Ensure types is always an array of objects with a 'name' property
      const safeTypes = Array.isArray(types) ? types.filter(t => t && typeof t === 'object' && 'name' in t) : [];
      setRoleTypes(safeTypes);
    });
  }, []);

  useEffect(() => {
    if (role) {
      setRoleName(role.roleName || "");
      setDescription(role.description || "");
      setType(role.type || null);
    } else {
      setRoleName("");
      setDescription("");
      setType(null);
    }
  }, [role]);

  const handleConfirm = async () => {
    setLoading(true);
    if (role) {
      await updateRoleDo({
        roleName,
        description,
        type: type!,
      }, role.id);
      addAlert(dispatch, "Role updated successfully");
    } else {
      await postRoleDO({    
        roleName,
        description,
        type: type!,
        isManager: false
      });
      addAlert(dispatch, "Role added successfully");
    }
    setLoading(false);
    if (onSubmit) onSubmit();
  };

  return (
    <AloveDialog
      dialogType={role ? DialogType.EditRole : DialogType.AddNewRole}
      dialogTitle={role ? "Edit Role" : "Add New Role"}
      dialogBody={role ? "Update the details for this role." : "Enter the details for the new role."}
      dialogConfirm={role ? "Save" : "Add"}
      valid={!!roleName && !!type}
      handleConfirm={handleConfirm}
      width="400px"
    >
      <MDInput
        label="Role Name"
        required
        value={roleName}
        onChange={e => setRoleName(e.target.value)}
      />
      <MDInput
        label="Description"
        value={description}
        onChange={e => setDescription(e.target.value)}
      />
      <Autocomplete
        options={roleTypes}
        getOptionLabel={(option) => option.name}
        value={roleTypes.find(rt => rt.name === type?.name) || null}
        onChange={(_, value) => setType(value || null)}
        renderInput={(params) => (
          <MDInput
            {...params}
            label="Type"
            required
          />
        )}
        isOptionEqualToValue={(option, value) => option.name === value.name}
      />
    </AloveDialog>
  );
}; 